<template>
  <v-btn block small :href="buyAlbumUrl" target="_blank" :color="$config.colors.primary" :title="$lang.buyAlbumViaPayPal(album.title)">{{ $lang.buyAlbum($config.payPalAlbumPrice) }}</v-btn>
</template>
<script>
export default {
  name: 'BuyAlbum',
  props: {
    album: {
      type: Object,
      required: true
    }
  },
  computed: {
    buyAlbumUrl () {
      // const config = this.$config
      // const album = this.album
      // return `https://paypal.com/cgi-bin/webscr?cmd=_xclick&business=${config.payPalEmail}&item_name=${this.$lang.payPalItemTitle(album.title)}&item_number=&amount=${config.payPalAlbumPrice}&return=${config.payPalReturnPage}&cn=&no_shipping=0&no_note=1&currency_code=${config.payPalCurrency}&bn=PP%2dBuyNowBF&charset=UTF%2d8&rm=2&undefined_quantity=1&custom=`
      return `${this.album.url}?action=buy&from=embed`
    }
  }
  // methods: {
  //   setAlbumInLocalStorage () {
  //     localStorage.setItem('purchase', JSON.stringify(this.album))
  //   }
  // },
  // mounted () {
  //   console.log(this.album)
  // }
}
</script>



// WEBPACK FOOTER //
// src/components/buy-album.vue